import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { withStyles } from '@material-ui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import withAll from 'components/base/withAll';
import {
  getBrandSafetyReports as getBrandSafetyReportsAction,
  refreshBrandSafetyReport as refreshBrandSafetyReportAction,
} from 'redux/brandSafetyReports/actions';
import styles from './styles';

const SuccessMessage = () => <React.Fragment>Report was queued for update.</React.Fragment>;

const RefreshAction = ({
  classes,
  report,
  isLoading,
  getBrandSafetyReports,
  refreshBrandSafetyReport,
}) => {
  const onClick = async () => {
    await refreshBrandSafetyReport(report.id);
    toast.success(<SuccessMessage />);
    getBrandSafetyReports();
  };

  return (
    <React.Fragment>
      <Button className={classes.root} onClick={onClick} disabled={isLoading}>
        <FontAwesomeIcon icon={faRedo} />
      </Button>
    </React.Fragment>
  );
};

RefreshAction.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  report: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getBrandSafetyReports: PropTypes.func.isRequired,
  refreshBrandSafetyReport: PropTypes.func.isRequired,
};

const mapStateToProps = ({ brandSafetyReport }) => ({
  isLoading: brandSafetyReport.loading,
});

const mapDispatchToProps = {
  getBrandSafetyReports: getBrandSafetyReportsAction,
  refreshBrandSafetyReport: refreshBrandSafetyReportAction,
};

export default withAll(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(RefreshAction);
